import { render, staticRenderFns } from "./RateEchart.vue?vue&type=template&id=bd5f3600&scoped=true&"
import script from "./RateEchart.vue?vue&type=script&lang=js&"
export * from "./RateEchart.vue?vue&type=script&lang=js&"
import style0 from "./RateEchart.vue?vue&type=style&index=0&id=bd5f3600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5f3600",
  null
  
)

export default component.exports